"use client"

import eventBus from "lib/events"

interface Props {
    chapters: { startTime: number; value: string }[] | undefined | null
    /** Whether chapters are seekable/clickable; if false, chapters are shown without links. */
    seekable?: boolean
}

function formatTime(seconds: number) {
    const date = new Date(0)
    date.setSeconds(seconds)

    if (seconds >= 3600) {
        return date.toISOString().substring(11, 19)
    } else {
        return date.toISOString().substring(14, 19)
    }
}

export function Chapters({ chapters, seekable = true }: Props) {
    if (!chapters || chapters.length === 0) {
        return <></>
    }

    const seekTo = (time: number) => {
        eventBus.dispatch("academy-video-seek", time)
    }

    return (
        <nav className="pb-4 lg:pb-0">
            <h2 className="mb-2 text-lg font-medium text-gray-900 dark:text-gray-100">Chapters</h2>
            <ul className="space-y-2">
                {chapters.map((chapter, index) => (
                    <li key={index}>
                        {seekable ? (
                            <button
                                className="text-primary-800 cursor-pointer text-left hover:underline dark:text-primary-200 dark:hover:text-primary-100"
                                onClick={() => seekTo(chapter.startTime)}
                            >
                                {formatTime(chapter.startTime)} - {chapter.value}
                            </button>
                        ) : (
                            <span className="text-gray-800 dark:text-gray-200">
                                {formatTime(chapter.startTime)} - {chapter.value}
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    )
}
